import { z } from 'zod'

export const ConfigurationJudicialZod = z.object({
  filterByBirthDate: z.boolean().optional().default(false),
  provincialSearchWithBirthDate: z.boolean().optional().default(false),
  municipalNumberOfYears: z.number().optional().default(30),
  pricePerSearch: z.number().optional().default(3.95),
  pricePerRecord: z.number().optional().default(3.95),
})
